/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrydescription1Inputs */

const en_entrydescription1 = /** @type {(inputs: Entrydescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do guests get in?`)
};

const de_entrydescription1 = /** @type {(inputs: Entrydescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie kommen Gäste rein?`)
};

/**
* | output |
* | --- |
* | "How do guests get in?" |
*
* @param {Entrydescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrydescription1 = /** @type {((inputs?: Entrydescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrydescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrydescription1(inputs)
	return de_entrydescription1(inputs)
});
export { entrydescription1 as "entryDescription" }